module.exports = __webpack_public_path__ + "img/gift_1.aa6812db.jpg";